<template>
  <div class="file" v-if="file">
    <file-icon width="30" height="33"></file-icon>
    <div class="file-description error" v-if="error">
      <span :title="file.name" class="file-name">{{ file.name }}</span>
      <small>{{ $t("exchange-file-upload-failed") }}</small>
    </div>
    <div v-else class="file-description">
      <span :title="file.name" class="file-name">{{ file.name }}</span>
      <small v-if="uploadingFinished">{{ file.size | convertSize }} kb</small>
      <div v-else class="progress-bar"></div>
    </div>
    <button class="remove-file" type="button" @click="removeFile()">
      <close-icon width="8px" height="8px" weight="light"></close-icon>
    </button>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import FileIcon from "@/components/icons/FileIcon";
import CloseIcon from "@/components/icons/CloseIcon";

export default {
  name: "ExchangeFile",
  props: {
    file: {
      required: true
    },
    index: {
      required: true
    }
  },
  components: {
    FileIcon,
    CloseIcon
  },
  data() {
    return {
      error: false,
      uploadingFinished: false,
      fileId: null,
      source: axios.CancelToken.source()
    };
  },
  computed: {
    ...mapState("exchange", ["exchangeId", "choosenFiles"])
  },
  methods: {
    ...mapActions("common", ["setLoading", "showModal"]),
    ...mapActions("exchange", ["updateExchangeFiles"]),
    sendFiles() {
      this.setLoading(false);
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("files", this.file);
        axios({
          url: `/outgoing/exchange/${this.exchangeId}/file`,
          method: "POST",
          data: formData,
          cancelToken: this.source.token
        })
          .then(res => {
            if (res.data) {
              this.updateExchangeFiles(res.data);
              this.fileId = res.data.id;
              this.uploadingFinished = true;
              this.setLoading(false);
            }
            resolve(res);
          })
          .catch(err => {
            this.setLoading(false);
            reject(err);
          });
      });
    },
    removeFile() {
      const payload = {
        uploadFailed: this.error,
        index: this.index,
        exchangeId: this.exchangeId
      };
      if (!this.uploadingFinished) {
        this.source.cancel();
      } else {
        Object.assign(payload, {
          fileId: this.fileId
        });
      }

      this.$emit("removeFile", payload);
      if (this.error) {
        this.$emit("decreaseFailedUploadsCounter");
      }
    }
  },
  async mounted() {
    if (!this.file) return;
    this.sendFiles()
      .then()
      .catch(err => {
        const rejectedResponseBody = err.response ? err.response.data : err;
        if (err.response && err.response.status === 413) {
          this.showModal({
            title: "entity-too-large"
          });
          this.error = true;
          this.$emit("increaseFailedUploadsCounter");
        } else if (rejectedResponseBody.errorCode === "UNAUTHORIZED") {
          this.showModal({
            title: rejectedResponseBody.errorCode
          });
        } else {
          this.showModal({
            title: rejectedResponseBody.errorCode
          });
          this.error = true;
          this.$emit("increaseFailedUploadsCounter");
        }
      });
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/styles/variables";

.file {
  display: flex;
  align-items: stretch;
  font-size: 14px;
  margin-bottom: 10px;
  svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
    flex-shrink: 0;
  }
  .file-description {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .progress-bar {
    width: 100%;
    height: 4px;
    background: $middle-gray;
  }
  .remove-file {
    background: $middle-gray;
    border: 1px solid #979797;
    width: 14px;
    height: 14px;
    display: flex;
    align-self: center;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    padding: 0;
    margin: 3px -14px 3px 3px;
    svg {
      margin: 0;
    }
  }
}
.file-description:not(.error) {
  small {
    color: $placeholder-color;
  }
}

.error {
  color: $error-color;
}
</style>
